import React, { ReactElement } from 'react';
import { CircularProgress, Stack, StackProps } from '@mui/material';
import { Error } from './error';

type StaticLoaderProps = {
  error?: boolean;
  requires?: never;
  children?: never;
  color?: string;
};

type DynamicLoaderProps<T> = {
  error?: boolean;
  requires: T | undefined | null;
  children: (data: T) => ReactElement;
  color?: string;
};

type LoaderProps<T> = (StaticLoaderProps | DynamicLoaderProps<T>) &
  Omit<StackProps, 'children'>;

export function Loader<T = unknown>(props: LoaderProps<T>) {
  const { error, requires, children, color, ...other } = props;

  // loading failed
  if (error) return <Error {...other} />;

  // content is available
  if (children && requires !== undefined && requires !== null)
    return children(requires);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={2}
      minHeight={200}
      {...other}
    >
      <CircularProgress sx={{ color }} />
    </Stack>
  );
}
